export interface LegalMapMapping {
  id: string;
  lotId: string;
  lotNumber: string;
  pageNumber: number;
  pdfX: number;
  pdfY: number;
  pdfPageWidth: number;
  pdfPageHeight: number;
}

export interface LegalMapStampedPdfResponse {
  documentId: string;
  documentName: string;
}

export interface LegalMapLotView {
  lotId: string;
  lotNumber: string;
  status: string;
  legalCoordinateMapping: LegalMapMapping | null;
}

export type AiProposalConfidence = 'high' | 'medium' | 'low';

export interface AiLegalMapInfo {
  unmappedCount: number;
  hasLegalMap: boolean;
  maxLotsPerRun: number;
  inProgress: boolean;
}

export interface AiLegalMapProposal {
  lotId: string;
  lotNumber: string;
  pageNumber: number;
  pdfX: number;
  pdfY: number;
  pdfPageWidth: number;
  pdfPageHeight: number;
  normalizedX: number;
  normalizedY: number;
  confidence: AiProposalConfidence;
}

export interface AiLegalMapResult {
  proposals: AiLegalMapProposal[];
  unidentifiedLotNumbers: string[];
  droppedIdentifiers: string[];
  summary: string;
}

export interface AiLegalMapStartResponse {
  runId: string;
}

export enum AiLegalMapProgressStatus {
  Idle = 'idle',
  Running = 'running',
  Completed = 'completed',
  Failed = 'failed',
  Cancelled = 'cancelled'
}

export interface AiLegalMapProgress {
  runId: string;
  projectId: string;
  status: AiLegalMapProgressStatus;
  phase: string | null;
  message: string | null;
  percent: number;
  elapsedMs: number;
  updatedAt: string;
  result: AiLegalMapResult | null;
}

export interface AiLegalMapAcceptItem {
  lotId: string;
  pageNumber: number;
  pdfX: number;
  pdfY: number;
  pdfPageWidth: number;
  pdfPageHeight: number;
}

export interface AiPreviewPin {
  lotId: string;
  lotNumber: string;
  pageNumber: number | null;
  pdfX: number | null;
  pdfY: number | null;
  pdfPageWidth: number | null;
  pdfPageHeight: number | null;
  confidence: AiProposalConfidence | null;
  mapped: boolean;
  confirmed: boolean;
}
